const {Answers} = require('./consts');

function getIsOtherAnswerWithTextSelected(value) {
    if (Array.isArray(value)) {
        return value.includes(Answers.OTHER_ANSWER_WITH_TEXT);
    }

    return String(value) === Answers.OTHER_ANSWER_WITH_TEXT;
}

module.exports = {
    getIsOtherAnswerWithTextSelected
};
